import { SUCCESS_CODE } from '@/constants'
import { MockMethod } from 'vite-plugin-mock'

const timeout = 1000

export default [
  // 分析页统计接口
  {
    url: '/mock/analysis/total',
    method: 'get',
    timeout,
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: {
          users: 102400,
          messages: 81212,
          moneys: 9280,
          shoppings: 13600
        }
      }
    }
  },
  // 用户来源
  {
    url: '/mock/analysis/userAccessSource',
    method: 'get',
    timeout,
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: [
          { value: 1000, name: '未签署' },
          { value: 310, name: '已签署' }
        ]
      }
    }
  },
  // 每周用户活跃量
  {
    url: '/mock/analysis/weeklyUserActivity',
    method: 'get',
    timeout,
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: [
          { value: 13253, name: 'analysis.monday' },
          { value: 34235, name: 'analysis.tuesday' },
          { value: 26321, name: 'analysis.wednesday' },
          { value: 12340, name: 'analysis.thursday' },
          { value: 24643, name: 'analysis.friday' },
          { value: 1322, name: 'analysis.saturday' },
          { value: 1324, name: 'analysis.sunday' }
        ]
      }
    }
  },
  // 每月销售额
  {
    url: '/mock/analysis/monthlySales',
    method: 'get',
    timeout,
    response: () => {
      return {
        code: SUCCESS_CODE,
        data: [
          { actual: 120, name: 'analysis.january' },
          { actual: 82, name: 'analysis.february' },
          { actual: 91, name: 'analysis.march' },
          { actual: 154, name: 'analysis.april' },
          { actual: 162, name: 'analysis.may' },
          { actual: 140, name: 'analysis.june' },
          { actual: 145, name: 'analysis.july' },
          { actual: 250, name: 'analysis.august' },
          { actual: 134, name: 'analysis.september' },
          { actual: 56, name: 'analysis.october' },
          { actual: 99, name: 'analysis.november' },
          { actual: 123, name: 'analysis.december' }
        ]
      }
    }
  }
] as MockMethod[]
